import React from "react";
import { useTranslation } from "react-i18next";
import { Text } from "@fragments";
import { LocalOfferRounded } from "@mui/icons-material";
import AvailabilityInPlan from "@components/AvailabilityInPlan";

export default function Availability({ value, onChange, community }) {
    const { t } = useTranslation("contentModals");

    return (
        <>
            <Text.h3
                value={t("manageContent.availability.title")}
                left={<LocalOfferRounded />}
                className="mb-1 mt-5"
            />
            <AvailabilityInPlan
                community={community}
                initialValues={value?.plans}
                onChange={onChange}
            />
        </>
    );
}
